module.exports = __webpack_public_path__ + "static/media/twitterlogo.dad59ec7.svg";